import React, { useEffect, useRef, useState } from 'react';
import { graphql, StaticQuery } from 'gatsby';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import { Header as BaseHeader } from '@lux/components';
import { getCookie } from '@lux/helpers';
import { HeaderWrapper } from './style';
import BasicHeader from './BasicHeader';
import RrpHeader from './RrpHeader';

import {
  getUIAMLoginUrl,
  sdAccountSummary
} from '../../config';

import { api, apigeeAuthActions } from '@detox/actions';
import isFeatureFlagEnabled from '../../helpers/feature-flags';
import { UIAM_FLOW } from '../../types/featureFlag.types';
import { useDispatch } from 'react-redux';
import useInterceptor from '../../hooks/useInterceptor';
import CONSTANT from '../../constants/common';
import { deleteCookie } from '../../helpers/set-cookie';

const revokeTokenApi = api.onlineApi.revokeToken;

export const PureHeader = withTheme(props => {
  const { data, baseUrl, shoppingCartUrl, theme, isRrpHeader } = props;
  const dispatch = useDispatch();
  const apiGeeResponseReceivedRef = useRef(false);
  const { header } = data;
  const { useBasicHeader } = theme;

  const isUIAMFeatureEnable = isFeatureFlagEnabled(UIAM_FLOW);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const isAccessTokenExists = window.sessionStorage.getItem(
      'ApigeeAuthToken'
    );
    if (isUIAMFeatureEnable && !isAccessTokenExists) {
      dispatch(
        apigeeAuthActions.getApigeeAuthToken(
          () => (apiGeeResponseReceivedRef.current = true)
        )
      );
    }
  }, []);

  useInterceptor();

  useEffect(() => {
    if (isUIAMFeatureEnable) {
      const uiamAccessToken = getCookie(CONSTANT.UIAM_ACCESS_TOKEN);
      if (uiamAccessToken && uiamAccessToken.length > 0) {
        setIsLoggedIn(true);
      } else {
        setIsLoggedIn(false);
      }
    }

  }, []);

  useEffect(() => {
    if (isUIAMFeatureEnable) {
      const uiamAccessToken = getCookie(CONSTANT.UIAM_ACCESS_TOKEN);
      if (uiamAccessToken && uiamAccessToken.length > 0) {
        const revokeTokenCall = async () => {
          try {
            const result = await revokeTokenApi(uiamAccessToken);
            if (result?.code === CONSTANT.REVOKE_SUCCESS) {
              deleteCookie(CONSTANT.UIAM_ACCESS_TOKEN);
              window.open(getUIAMLoginUrl(sdAccountSummary, true), '_self');
            }
          } catch (e) {
            setIsLoggedIn(false);
          }
        };

        header.avatarMenuItems.push({
          title: header.logoutButtonText,
          href: '/logout', // This href does nothing but provide a vanity url if user hovers over the anchor tag
          onClick: e => {
            e.preventDefault();
            revokeTokenCall();
          }
        });
      }
    }


  }, [
    baseUrl,
    header.avatarMenuItems,
    header.logoutButtonText
  ]);

  // Set Products & Services as default selection
  header.menuItems[0].item.active = true;

  return useBasicHeader ? (
    <BasicHeader />
  ) : isRrpHeader ? (
    <RrpHeader
      data={header}
      baseUrl={baseUrl}
      shoppingCartUrl={shoppingCartUrl}
      isLoggedIn={isLoggedIn}
    />
  ) : (
    <HeaderWrapper>
      <BaseHeader
        baseUrl={baseUrl}
        avatarMenuItems={header.avatarMenuItems}
        firstLevelLinks={header.firstLevelLinks}
        logo={header.logo}
        shoppingCartUrl={shoppingCartUrl}
        showAvatar={isLoggedIn}
        showHamburger={true}
        showLoginButton={!isLoggedIn}
        showSearch={true}
        showShoppingCart={true}
        menuItems={header.menuItems}
        loginUrl={header.loginButtonUrl}
      />
    </HeaderWrapper>
  );
});

PureHeader.propTypes = {
  /** The header datamodel */
  data: PropTypes.object,
  /** Set the base url */
  baseUrl: PropTypes.string,
  /** Set if logged in */
  login: PropTypes.bool,
  /** Set the shopping cart url */
  shoppingCartUrl: PropTypes.string
};

/* istanbul ignore next */
const Header = props => (
  <StaticQuery
    query={graphql`
      {
        header {
          menuItems: headerList {
            item: linkItem {
              href: src
              title
            }
            subMenu {
              subMenu: menuList {
                item: linkItem {
                  subMenu: menuList {
                    item: linkItem {
                      title
                      href: src
                    }
                  }
                  href: src
                  title
                }
              }
              item: menuSectionTitle {
                title
                href: src
              }
            }
          }
          firstLevelLinks: linkItemList {
            active
            title
            href: src
          }
          avatarMenuItems: links {
            title
            href: src
          }
          logo {
            link
            alt
            href: src
          }
          loginButtonUrl
          logoutButtonText
        }
      }
    `}
    render={data => <PureHeader data={data} {...props} />}
  />
);

export default Header;
